import "./style.scss";
export const statusCard = (approvalStatus, laborBillRate, installerPayRate, percentReturn) => {
  return `
    <div class="status-card">
      <div class="d-flex justify-content-between">
        <div class="d-flex">
            <div class="status-card__header d-flex">Approval Status</div>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="store-card ${approvalStatus === "APPROVED" ? "approved-icon" : approvalStatus === "INITIALIZE" ? "initialize-icon" : approvalStatus === "PENDING" ? "pending-icon" : ""}"></div>
          </div>
          <div class="d-flex">
            <div class="status-card__text d-flex">${approvalStatus}</div>
          </div>
        </div>
      </div>
      <div class="status-card__data__divider"></div>
      <div class="status-card__space d-flex justify-content-between">
        <span class="status-card status-card__header d-flex">
        ${approvalStatus === "APPROVED" ? "Approved Bill Rate" : approvalStatus === "REJECTED" ? "Rejected Bill Rate" : approvalStatus === "PENDING" ? "Pending Bill Rate" : "Bill Rate"}
        </span>
        <span class="status-card__text d-flex">${laborBillRate}</span>
      </div>
      <div class="status-card__space d-flex justify-content-between">
        <span class="status-card status-card__header d-flex">
        ${approvalStatus === "APPROVED" ? "Approved Installer Pay Rate" : approvalStatus === "REJECTED" ? "Rejected Installer Pay Rate" : approvalStatus === "PENDING" ? "Pending Installer Pay Rate" : "Installer Pay Rate"}
        </span>
        <span class="status-card__text d-flex">${installerPayRate}</span>
      </div>
      <div class="status-card__data d-flex justify-content-between">
        <span class="status-card status-card__header d-flex">New Percent Return</span>
        <span class="status-card__text d-flex">${percentReturn}</span>
      </div>
    </div>
    `;
};
